<template>
	<v-tabs
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
		<v-tab key="Categorie" ripple class="secondary-tab">
			Categorie
		</v-tab>
		<v-tab key="Stampa" ripple class="secondary-tab">
			Stampa
		</v-tab>
		<v-tab key="Template" ripple class="secondary-tab">
			Template
		</v-tab>
		<v-tab key="Scheduling" ripple class="secondary-tab">
			Scheduling
		</v-tab>
		<v-tab key="Privacy" ripple class="secondary-tab">
			Privacy
		</v-tab>
		<v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="pb-offset background-1 pt-3" key="Campi">

			<v-row class="ma-0 pb-offset">

				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector
						model-def="company"
					></fields-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Azioni">
			<v-row class="ma-0 pb-offset">

				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="company"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Categorie">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
					<crud
						title='Categorie aziende'
						action-icon='widgets'
						model-def='companycategories'
						action-position='absolute'
						:crud-dialog="true"
					></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
					<crud
						title='Aree aziende'
						action-icon='widgets'
						model-def='companyareas'
						action-position='absolute'
						:crud-dialog="true"
					></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
					<crud
						title="Tipo aziende"
						action-icon='settings'
						model-def='generaltypes-company_type'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
					<crud
						title="Stato aziende"
						action-icon='settings'
						model-def='generaltypes-company_status'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
					<crud
						title="Fonte aziende"
						action-icon='settings'
						model-def='generaltypes-source'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
					<crud
						title="Frequenza fatturazione"
						action-icon='settings'
						model-def='generaltypes-invoice_frequency'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Stampa">
			<print-setting
				model="company"
			></print-setting>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Template">
			<crud
				model-def="templates-company"
				action-icon="dynamic_feed"
				title="Template"
			></crud>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Scheduling">
			<companies-scheduling-options
			></companies-scheduling-options>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Privacy">
			<companies-privacy
			></companies-privacy>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Altro">
			<companies-options
			></companies-options>
		</v-tab-item>
	</v-tabs>
</template>
<script>

import PrintSetting from '@/components/common/PrintSetting'
import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import CompaniesOptions from '@/components/modules/crm/settings/CompaniesOptions'
import CompaniesPrivacy from '@/components/modules/crm/settings/CompaniesPrivacy'
import SimulateMailSchedule from '@/components/modules/crm/settings/SimulateMailSchedule'
import CompaniesSchedulingOptions from '@/components/modules/crm/settings/CompaniesSchedulingOptions'

	export default {
		name:'companies-settings',
        components: {
			PrintSetting,
			FieldsSelector,
			ActionsSelector,
			CompaniesOptions,
			CompaniesPrivacy,
			SimulateMailSchedule,
			CompaniesSchedulingOptions,
        },
	}
  </script>
